<template>

    <button @click="openCart" type="button" class="flex flex-shrink-1 w-[60px] xl:w-auto h-full justify-center items-center px-4 xl:px-8 group hover:bg-white/5 transition-all">
        <span class="inline-flex items-center w-[40px] h-[37px] mx-auto relative left-0.5 xl:left-1 bottom-2 xl:bottom-1">
            <span class="flex items-end h-full">
                <svg class="w-[16px] h-[20px] xl:w-[19px] xl:h-[22px]" xmlns="http://www.w3.org/2000/svg" width="19.635" height="22.73" viewBox="0 0 19.635 22.73">
                    <g data-name="Raggruppa 1300" transform="translate(-4110.463 -41.242)">
                        <path id="Tracciato_1456" data-name="Tracciato 1456" d="M4112,48.131h16.567l1,15.341H4111Z" fill="none" stroke="#fff" stroke-width="1"/>
                        <path id="Tracciato_1457" data-name="Tracciato 1457" d="M4117.447,55.8V44.575a2.833,2.833,0,0,1,2.833-2.833h0a2.833,2.833,0,0,1,2.834,2.833V55.8" fill="none" stroke="#fff" stroke-width="1"/>
                    </g>
                </svg>
            </span>
            <span class="relative h-full -mb-5 -ml-1 xl:mb-0 xl:ml-0">
                <span class="w-[17px] h-[17px] xl:w-[18px] xl:h-[18px] bg-primary-400 rounded-full inline-flex items-center justify-center text-xxs xl:text-xxs text-white text-center -tracking-[.01rem] leading-none">
                    <span class="relative block mx-auto" v-text="counter"></span>
                </span>
            </span>
        </span>
    </button>

</template>

<style lang="scss" scoped>
</style>

<script>

    export default {
        props: ['initCounter', 'cartLink', 'theme'],
        data() {
            return {
                counter: 0
            }
        },
        mounted() {
            this.counter = parseInt(this.initCounter);
            this.$eventHub.$on('cart.added', payload => {
                this.counter = parseInt(payload.count);
            });

            this.$eventHub.$on('cart.updated.simpleQty', payload => {
                this.counter = payload;
            });
        },
        beforeDestroy() {
            this.$eventHub.$off('cart.added');
            this.$eventHub.$off('cart.updated.simpleQty');
        },
        methods: {
            openCart() {
                if(this.counter == 0) {
                    window.location.href = this.$root.langRoute('/shop')
                    return
                }
                if(window.innerWidth < 1280) {
                    window.location.href = this.$root.langRoute('/carrello');
                }else{
                    this.$eventHub.$emit('cart.show', {});
                }
            },
        }
    }

</script>
